module.exports = __webpack_public_path__ + "static/media/group-doctor.73a25699.png";